module.exports = __webpack_public_path__ + "img/pricing.f76b550f.jpg";